import { render, staticRenderFns } from "./advTrackPlatform.vue?vue&type=template&id=2b2e834a"
import script from "./advTrackPlatform.vue?vue&type=script&lang=js"
export * from "./advTrackPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports